/* merchant/sagas*/
import { all, fork, put, takeEvery } from "redux-saga/effects";
import { isEmpty } from "ramda";
import { get, merge } from "lodash";
import { AuditActionTypes } from "./types";
import { fetchRequest, fetchError, fetchSuccess } from "./actions";
import { dirty } from "../session/actions";
import { isAuthError } from "../";
import { fetch } from "../../repo/audit";
import { Data, DiffItem } from "./types";
import databaseAttribute from "../../lib/databaseAtributes.json";

const isObject = (obj: any) =>
  Object.prototype.toString.call(obj) === "[object Object]";
const isArray = (obj: any) => Array.isArray(obj);

const convertDataNested = (
  diffItem: DiffItem,
  Diff: Array<string>,
  object: Record<string, any>,
  labelLastItem: string
): any => {
  if (Diff.length === 0) {
    return object;
  } else {
    const lastItem = Diff[Diff.length - 1];
    const newArr = Diff.slice(0, Diff.length - 1);
    const newObject: Record<string, any> = {};

    if (lastItem?.includes("[") || lastItem?.includes("]")) {
      return convertDataNested(diffItem, newArr, object, lastItem[1]);
    }
    const convertedLastItem =
      databaseAttribute[lastItem as keyof typeof databaseAttribute];
    if (Object.keys(object).length === 0) {
      const item = `${convertedLastItem ? convertedLastItem : lastItem}`;
      newObject[item] = {
        FromValue: diffItem.From ? String(diffItem.From) : "",
        ToValue: diffItem.To ? String(diffItem.To) : "",
        FromDisplay: diffItem.From !== undefined
          ? String(diffItem.From).substring(0, 50)
          : "",
        ToDisplay: diffItem.To !== undefined ? String(diffItem.To).substring(0, 50) : "",
      };
      return convertDataNested(diffItem, newArr, newObject, "");
    }

    const item = `${convertedLastItem ? convertedLastItem : lastItem}${
      labelLastItem ? ` (${labelLastItem})` : ""
    }`;
    newObject[item] = object;
    return convertDataNested(diffItem, newArr, newObject, "");
  }
};

const getArrayItemName = (arr: any, path: string, index: number) => {
  let name = `(${index})`;
  const item = get(arr, `${path}[${index}]`, {});
  if (path === "Processor" && item.ProcessorName) {
    name = item.ProcessorName as string;
  }
  return name;
};

const getItemName = (item: any, path: string, index: number) => {
  let name = `(${index})`;
  if (path === "Processor" && item.ProcessorName) {
    name = item.ProcessorName;
  }
  return name;
};

const jsonDiffConvert = (
  from: any,
  path: string,
  rs: Array<DiffItem>,
  status: string,
  oldData: any
) => {
  if (isObject(from)) {
    const keys = Object.keys(from);
    keys.forEach((k) => {
      if (k.endsWith("__added")) {
        if (isObject(from[k])) {
          const newObj = {}
          Object.keys(from[k]).map(key => {
            newObj[`${key}__added`] = from[k][key];
          })
          jsonDiffConvert(
            newObj,
            `${path ? path + "." : ""}${k.replace("__added", "")}`,
            rs,
            status,
            oldData
          );
        } else {
          rs.push({
            Path: `${path ? path + "." : ""}${k.replace("__added", "")}`,
            From: "",
            To: from[k],
            type: "insert",
          });
        }
      } else if (k.endsWith("__deleted")) {
        rs.push({
          Path: `${path ? path + "." : ""}${k.replace("__deleted", "")}`,
          From: from[k],
          To: "",
          type: "delete",
        });
      } else if (
        from[k].hasOwnProperty("__old") &&
        from[k].hasOwnProperty("__new")
      ) {
        rs.push({
          Path: `${path ? path + "." : ""}${k}`,
          From: from[k].__old,
          To: from[k].__new,
          type: "update",
        });
      } else if (isArray(from[k])) {
        jsonDiffConvert(
          from[k],
          `${path ? path + "." : ""}${k}`,
          rs,
          status,
          oldData
        );
      } else if (isObject(from[k])) {
        jsonDiffConvert(
          from[k],
          `${path ? path + "." : ""}${k}`,
          rs,
          status,
          oldData
        );
      } else {
        if (status === "+") {
          rs.push({
            Path: `${path ? path + "." : ""}${k}`,
            From: "",
            To: from[k],
            type: "insert",
          });
        } else {
          rs.push({
            Path: `${path ? path + "." : ""}${k}`,
            From: from[k],
            To: "",
            type: "delete",
          });
        }
      }
    });
  }
  if (isArray(from)) {
    for (let i = 0; i < from.length; i++) {
      if (isArray(from[i]) && from[i].length === 2 && from[i][0] === "-") {
        if (isObject(from[i][1])) {
          jsonDiffConvert(
            from[i][1],
            `${path ? path + "." : ""} ${getArrayItemName(oldData, path, i)}`,
            rs,
            "-",
            oldData
          );
        } else if (from[i][1].trim()) {
          rs.push({
            Path: `${path ? path + "." : ""}${from[i][1]}`,
            From: true,
            To: false,
            type: "delete",
          });
        }
      } else if (
        isArray(from[i]) &&
        from[i].length === 2 &&
        from[i][0] === "+"
      ) {
        if (isObject(from[i][1])) {
          jsonDiffConvert(
            from[i][1],
            `${path ? path + "." : ""} ${getItemName(from[i][1], path, i)}`,
            rs,
            "+",
            oldData
          );
        } else if (from[i][1].trim()) {
          rs.push({
            Path: `${path ? path + "." : ""}${from[i][1]}`,
            From: false,
            To: true,
            type: "insert",
          });
        }
      } else if (
        isArray(from[i]) &&
        from[i].length === 2 &&
        from[i][0] === "~"
      ) {
        jsonDiffConvert(
          from[i][1],
          `${path ? path + "." : ""} ${getArrayItemName(oldData, path, i)}`,
          rs,
          status,
          oldData
        );
      } else if (isObject(from[i])) {
        jsonDiffConvert(
          from[i],
          `${path ? path + "." : ""} ${getArrayItemName(oldData, path, i)}`,
          rs,
          status,
          oldData
        );
      } else if (!isArray(from[i]) && !isObject(from[i]) && from[i].trim()) {
        rs.push({
          Path: `${path ? path + "." : ""}${from[i]}`,
          From: false,
          To: true,
          type: "insert",
        });
      }
    }
  }
  return rs;
};

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const audit = yield fetch(action.payload.id, action.payload.params);
    if (audit.errors && !isEmpty(audit.errors)) {
      if (isAuthError(audit.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(audit.errors)));
    } else {
      audit.data = audit.data.map((item: Data) => {
        let dataAudit: Record<string, any> = {};
        try {
          const diffArr: Array<DiffItem> = [];
          jsonDiffConvert(
            item.attributes?.Data?.Diff?.attributes,
            "",
            diffArr,
            "",
            item.attributes?.Data?.From?.attributes,
          );

          diffArr.forEach((diffItem: DiffItem) => {
            const diffSplitItem = diffItem.Path.split(".");
            const dataNested = convertDataNested(
              diffItem,
              diffSplitItem,
              {},
              ""
            );
            dataAudit = merge(dataNested, dataAudit);
          });

          const newDataAudit = Object.keys(dataAudit).reduce(
            (result, oldKey) => {
              return { ...result, [oldKey]: dataAudit[oldKey] };
            },
            {}
          );
          return {
            ...item,
            dataDetail:
              Object.keys(newDataAudit).length > 0 ? newDataAudit : null,
          };
        } catch (error) {
          return {
            ...item,
            dataDetail: null,
          };
        }
      });
      console.log(audit)

      yield put(fetchSuccess(audit));
    }
  } catch (err) {
    console.log("err", err);
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(AuditActionTypes.FETCH, handleFetch);
}

export default function* auditSaga() {
  yield all([fork(watchFetchRequest)]);
}
